import $ from 'jquery';
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

gsap.registerPlugin(MotionPathPlugin);

interface Size {
  width: number;
  height: number;
}

interface EndPosition {
  x: number;
  y: number;
}

const initBubbles = (contentElement: HTMLElement): void => {
  const size: Size = { width: 0, height: 0 };

  const affiliated = contentElement.querySelector('.bubble-affiliated') as HTMLElement;
  const behind = contentElement.querySelector('.bubble-behind') as HTMLElement;
  const imagesData = contentElement.getAttribute('data-images');
  const availableImages: string[] = imagesData ? JSON.parse(imagesData) : [];

  const onResize = (): void => {
    const rect = contentElement.getBoundingClientRect();
    size.width = rect.width;
    size.height = rect.height;
  };

  onResize();
  $(window).on('resize', onResize);

  const getRandomImage = (): string | null => {
    if (availableImages.length === 0) return null;
    return availableImages[Math.floor(Math.random() * availableImages.length)];
  };

  const createBubble = (): HTMLElement => {
    const bubble = document.createElement('div');
    bubble.classList.add('bubble-avatar');

    const img = document.createElement('img');
    const randomImage = getRandomImage();
    if (randomImage) {
      img.src = randomImage;
    }
    img.alt = 'affiliated';
    img.style.width = '50px';
    img.style.height = '50px';
    img.style.display = 'block';
    img.style.objectFit = 'cover';

    bubble.appendChild(img);
    return bubble;
  };

  const animateBubble = (bubble: HTMLElement, isBehind: boolean = false, side: string = 'left'): void => {
    bubble.classList.add(side === 'left' ? 'bubble-left' : 'bubble-right');

    const startX = side === 'left'
      ? Math.random() * (30 - 20) + 20
      : size.width - (Math.random() * (250 - 150) + 150);

    const endPos: EndPosition = {
      x: side === 'left'
        ? Math.random() * (50 - 20) + 20
        : size.width - (Math.random() * (150 - 230) + 230),
      y: -220,
    };

    gsap.set(bubble, {
      x: startX,
      y: size.height + 100,
      transformOrigin: 'center',
      scale: isBehind ? 0.8 : 1.2,
      opacity: 1,
      rotation: (Math.random() * 180) - 90,
    });

    gsap.to(bubble, {
      duration: 10 + Math.random(),
      motionPath: { curviness: 1.5, path: [endPos] },
      scale: isBehind ? 0.6 : 1,
      rotation: 0,
      ease: 'power1.in',
      onComplete: () => {
        (isBehind ? behind : affiliated).removeChild(bubble);
      },
    });
  };

  const spawnBubble = (side: string): void => {
    if (!document.hidden && availableImages.length > 0) {
      const b = createBubble();
      if (!b) return;

      const isBehind = Math.random() > 0.5;
      (isBehind ? behind : affiliated).appendChild(b);

      animateBubble(b, isBehind, side);
    }
  };

  if (availableImages.length > 0) {
    spawnBubble('left');
    spawnBubble('right');

    setInterval(() => spawnBubble('left'), 1500);
    setInterval(() => spawnBubble('right'), 2000);
  }
};

$(() => {
  $('.bubbles-section').each((_index: number, element: HTMLElement) => {
    initBubbles(element);
  });
});
